import { Component, OnInit } from '@angular/core';
import { HeaderStyleTwoComponent } from '../header-style-two/header-style-two.component';
import { HometwoMainBannerComponent } from './hometwo-main-banner/hometwo-main-banner.component';
import { HometwoAboutComponent } from '../hometwo-about/hometwo-about.component';
import { HometwoCoursesComponent } from '../hometwo-courses/hometwo-courses.component';
import { PartnerStyleOneComponent } from '../partner-style-one/partner-style-one.component';
import { InstructorsStyleTwoComponent } from '../instructors-style-two/instructors-style-two.component';
import { RouterLink } from '@angular/router';
import { OurMissionComponent } from '../our-mission/our-mission.component';
import { FunfactsComponent } from '../funfacts/funfacts.component';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PublicNewsService } from 'src/app/services/public-news.service';
import { ActivityService } from 'src/app/services/activity.service';
import { NewsService } from 'src/app/services/news.service';
import { environment } from 'src/environments/environment.prod';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-home-page-two',
    templateUrl: './home-page-two.component.html',
})
export class HomePageTwoComponent implements OnInit {
 
    news: any[] = [];
    publicNews: any[] = [];
    activities: any[] = [];
    constructor(
        
        public newsService: NewsService,
        public publicNewsService: PublicNewsService,
        public activityService: ActivityService,

    ) { }

    ngOnInit(): void {
        this.newsService.getAll$().subscribe(x => {
            this.news = x
        })
        this.publicNewsService.getAll$().subscribe(x => {
            this.publicNews = x
        })
        this.activityService.getAll$().subscribe(x => {
            this.activities = x
        })

    }
    createImgPath = (serverPath?: string) => {
        if (serverPath)
            return `${environment.patchUrl}/${serverPath}`;
    }

}